import { createContext, useContext } from 'react';
export type ScoQuestionAnswerPayload = {
  questionId: string;
  fieldType: string;
  optionIds?: string[];
  optionLabels?: string[];
  value?: string | number | null;
  valueJson?: unknown;
  freeText?: string;
  storedFileIds?: string[];
  currency?: string;
  /** Human-readable prose line shown in the chat bubble (machine tag hidden by default). */
  proseSummary: string;
};
export type ScoChatEmbedContextValue = {
  threadId?: string | null;
  parentCommentId?: string | null;
  /** Whether the current viewer can post (registered or guest-eligible). */
  canSubmit?: boolean;
  /**
   * True when this question is safe to interact with (present in embedsAsJson,
   * or stream already finished so body-only embeds are trusted).
   */
  isQuestionReady?: (questionId: string) => boolean;
  /**
   * Look up durable answer state for a question on the parent AI comment.
   * Prefer embedsAsJson; FE may also fall back to scanning later human messages.
   */
  getQuestionState?: (questionId: string) => {
    answered: boolean;
    answer?: {
      optionIds?: string[];
      value?: string | number | null;
      /** Structured answer payload (e.g. string[] tag titles for field-type=tags). */
      valueJson?: unknown;
      freeText?: string;
      optionLabels?: string[];
      fieldType?: string;
    } | null;
  };
  /**
   * Multi-question progress on the same parent message (1-based index).
   * Returns null when only one question or unknown.
   */
  getQuestionProgress?: (questionId: string) => {
    index: number;
    total: number;
  } | null;
  /** Post a structured answer as a human chat comment (prose + [sco-answer …]). */
  postAnswer?: (payload: ScoQuestionAnswerPayload) => Promise<void>;
};
export const ScoChatEmbedContext = createContext<ScoChatEmbedContextValue>({});
export const useScoChatEmbedContext = () => {
  return useContext(ScoChatEmbedContext);
};